import { Box, Typography } from '@mui/material'

import MetricForLocationBackground from '../../assets/metric-2.svg'
import MetricBackground from '../../assets/metric.svg'

export default function Metric({ label, text }: { label: string, text: any }) {
    const background = isNaN(text) ?
        `url(${MetricBackground}) no-repeat`
        : `url(${MetricForLocationBackground}) no-repeat`

    return (
        <Box
            sx={{
                width: '15vw',
                aspectRatio: 1 / 0.48,
                boxSizing: 'border-box',
                background: background,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                display: 'grid',
                placeContent: 'center',
                alignItems: 'center',
                rowGap: 1,
                paddingLeft: '12.5%',
                paddingRight: '2.5%',
                paddingY: '2.5%',
                '& > *': {
                    textAlign: 'center',
                    lineHeight: '1.125rem !important',
                }
            }}>
            <Typography variant="body1">
                {label}
            </Typography>
            <Typography variant="h6" className="text_primary_gradient">
                {text}
            </Typography>
        </Box>
    )
}
